/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'jquery',
	'underscore',
	'../common/NonVIPREventTarget',
	'../../../util/EventUtils'
], function($, _, NonVIPREventTarget, EventUtils) {

	class IndentedListEventTarget extends NonVIPREventTarget {
		constructor (...args) {
			super(...args);
			const options = args[0] || {};
			this.visControl = options.visControl;
			this.view = options.view;
			this.attributes = this.view.ATTRIBUTES;
			this.logger = options.logger;
			return this.getAPI();
		}

		/**
		 * Get the array of event targets based on the event.
		 * Event target represents a data point object that corresponds to the event.
		 *
		 * @param event	Event object
		 */
		getEventTargets (event) {
			const node = this._getTargetNode(event);
			if(!node) {
				return [];
			}

			var $node = $(node).closest('div');
			if(!$node.hasClass('item') || !this.mouseWithinBoundCheck(event)) {
				return [];
			}

			return this._getTargets(event, $node);
		}

		remove () {
			this.visControl = null;
			this.view = null;
			this.attributes = null;
			super.remove();
		}

		_getTargets (event, $node) {
			var targets = [];
			var row = $node && $node.attr(this.attributes.ROW_CLASS) ? $node.attr(this.attributes.ROW_CLASS) : '0';
			var col = $node && $node.attr(this.attributes.COLUMN_CLASS) ? $node.attr(this.attributes.COLUMN_CLASS) : '0';
			targets.push({
				key: row + ',' + col,
				type: 'item',
				source: $node,
				isEdgeSelect: true,
				values: this._getTargetValues($node),
				area: 'visualization'
			});

			return targets;
		}

		_getTargetValues($node) {
			let tuple = null;
			let values = [];
			try {
				var decodedTuple =  decodeURIComponent($node.attr('data-tuple'));
				tuple = JSON.parse(decodedTuple);
			} catch (err) {
				if (this.logger) {
					this.logger.warn('Unable to parse the string into a JSON object in the indented list.', decodedTuple);
				}
			}
			if (tuple) {
				values = _.values(tuple).map(tuple => (
					EventUtils.toDeprecatedPayload(tuple)
				));
			}
			// list has a single slot with multiple data items
			return [values];
		}
	}
	return IndentedListEventTarget;
});
